import http from "./http";

/**
 * Clínicas do usuário autenticado.
 *
 * salvia-811: devolve SEMPRE um array. Antes devolvia `null` quando a resposta
 * não trazia `success`, e quem chamava fazia `[...clinics]` e `.filter()` em
 * cima — a tela de clínicas quebrava em dois lugares só por o usuário ainda não
 * ter clínica nenhuma, que é o estado inicial de toda conta nova.
 *
 * "Não tem nenhuma" é uma resposta válida, não uma falha. Falha de verdade
 * (rede, 401, 500) continua sendo exceção e sobe pra quem chamou.
 *
 * @returns {Promise<Array>} lista, possivelmente vazia
 */
export async function getMyClinics() {
  const { data } = await http.get("/api/clinic/get-my-clinics");
  return Array.isArray(data?.data) ? data.data : [];
}

/**
 * Desfaz o vínculo do usuário autenticado com a clínica.
 * O backend recusa a saída do último médico (422).
 * @param {number|string} clinicId
 * @returns {Promise<string>} mensagem de confirmação
 */
export async function leaveClinic(clinicId) {
  const { data } = await http.delete(`/api/clinics/${clinicId}/leave`);
  return data?.message || "Você saiu da clínica.";
}

export async function getDoctorsByClinics(clinicId) {
  if (!clinicId) return null;
  const { data } = await http.get(
    `/api/clinic/get-doctors-by-clinic/${clinicId}`,
  );
  return data.success ? data.data : null;
}

/** `params.visibility: "visible"` tira os pacientes que o médico ocultou (SALVIA-955). */
export async function getPatientsByClinics(clinicId, params = {}) {
  if (!clinicId) return null;
  const { data } = await http.get(
    `/api/clinic/get-patients-by-clinic/${clinicId}`,
    { params },
  );
  return data.success ? data.data : null;
}

export async function getAssistantsByClinics(clinicId) {
  if (!clinicId) return null;
  const { data } = await http.get(
    `/api/clinic/get-assistants-by-clinic/${clinicId}`,
  );
  return data.success ? data.data : null;
}
